import { AxiosRequestConfig, AxiosResponse } from 'axios'

import { publicRequest } from '../api/publicRequest'

export const getPreRegistrationInfluencers = async (
  data: IInfluancersRequestData
): Promise<IInfluancersResponseData> => {
  const response: AxiosResponse<IInfluancersResponseData, AxiosRequestConfig> =
    await publicRequest.get(`v1/event/${data.eventId}/pre-registration/influencers`)
  return response.data
}

export const getPreRegistrationShareOptions = async (
  data: IShareOptionsRequestData
): Promise<IShareOptionsResponseData> => {
  const response: AxiosResponse<IShareOptionsResponseData, AxiosRequestConfig> =
    await publicRequest.get(`/v1/pre-registration/${data.hash}/confirmation-page`)
  return response.data
}

export const submitShareAction = async (
  data: ISubmitShareActionRequestData
): Promise<ISubmitShareActionResponseData> => {
  const { eventActionId, accessToken, hash } = data

  const response: AxiosResponse<ISubmitShareActionResponseData, AxiosRequestConfig> =
    await publicRequest.post(`/v1/pre-registration/${hash}/submit-action`, {
      data: {
        attributes: {
          phase: 'pre-registration',
          eventActionId: Number(eventActionId),
          accessToken,
        },
      },
    })
  return response.data
}
